// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__3Yxo6","message":"CookieConsent_message__1n7nl","cookieLink":"CookieConsent_cookieLink__Rc7P0","continueBtn":"CookieConsent_continueBtn__ij8S-"};